import { IRfqLot } from 'v2/modules/rfq/interfaces/rfq-lot.interface';

import { RfqStockLocationInterface } from '../../rfq/interfaces/rfq.interface';
import { CommonStatusEnum } from '../../shared/interfaces/common.interface';

export interface ILocation {
  id :number;
  createdAt :Date;
  updatedAt :Date;
  deletedAt :Date;
  createdBy :number;
  updatedBy :number;
  deletedBy :number;
  status :CommonStatusEnum;
  locationName :string;
  parentId :number;
  rfqStockLocations ?:RfqStockLocationInterface[];
  address :string;
  country :string;
  zip :string;
  state :string;
  city :string;
  streetAddress1 :string;
  streetAddress2 :string;
  meta :any;
  parent ?:ILocation;
  warehouseGroups ?:ILocationWarehouseGroup[];
}

export interface ILocationOld {
  id :number;
  created_at :string;
  updated_at :string;
  created_by :number;
  updated_by :number;
  location_name :string;
  parent_id :number;
  address ?:any;
  country :string;
  zip :string;
  state :string;
  city :string;
  street_address_2 ?:any;
  street_address_1 :string;
  meta ?:any;
  status :number;
  default_receiving_location :number;
  default_shipping_location :number;
  is_pick_location :number;
  is_active_bin :number;
  parent ?:any;
  picklist ?:any;
  rfqstock_locations :any[];
  shipstation_warehouses :any[];
}

export interface ILocationState {
  locations :ILocationOld[];
  loading :boolean;
  currentLocation :ILocationOld;
  currentQueryParams :{ [param :string] :string | string[] };
  lots :IRfqLot[];
}

export interface IBinLocation {
  address :string;
  city :string;
  country :string;
  created_at :Date;
  created_by :number;
  default_receiving_location :number;
  default_shipping_location :number;
  id :number;
  is_pick_location :number;
  location_name :string;
  meta :any;
  parent ?:IBinLocation;
  parent_id :number;
  rfqstock_locations :RfqStockLocationInterface[];
  state :string;
  status :CommonStatusEnum;
  street_address_1 :string;
  street_address_2 :string;
  updated_at :Date;
  updated_by :number;
  zip :string;
  defaultReceivingLocation :ILocation;
}

export interface ILocationWarehouseGroup {
  id :number;
  label :string;
  description :string;
  createdAt :string;
  updatedAt :string;
  scanToVerify :boolean;
  pickAndPackEnabled :boolean;
  pushOrder :boolean;
}

export enum EPickAndPackEnabledValue {
  AUTOMATIC = 'Automatic',
  MANUAL = 'Manual',
}

export interface ILocationInventory {
  id :number;
  locationId :string;
  appIntegrationAccountId :number;
  name :string;
  default :boolean;
  metadata :IMetadata;
  createdAt :string;
  updatedAt :string;
}

interface IMetadata {
  id :string;
  brand_id :string;
  created_on :number;
  modified_on :number;
  display_name :string;
  code :string;
  country_code :string;
  postal_code :string;
  active :boolean;
  sort :number;
  allows_overselling :boolean;
}
